import { getFunctions, httpsCallable } from 'firebase/functions';

export default async function reconcileInventoryTravelers({
  productDocId,
  productVersionId,
  travelerIds,
}) {
  const fn = httpsCallable(getFunctions(), 'reconcileInventoryTravelersV2');
  const { data } = await fn({
    productDocId,
    productVersionId,
    travelerIds,
  });
  return data;
}
